<template>
  <div>
    <ShowcaseSliderPreviewDialog
      :state="previewDialog"
      :items="showcases"
      @close="previewDialog = false"
    />
    <ShowcaseSliderNewDialog :state="newDialog" @close="newDialog = false" />
    <div class="d-flex justify-space-between align-center pa-4 pa-md-2">
      <div>
        <Breadcrumbs
          headline="Slider trang sản phẩm "
          :link="[{ text: 'Slider trang sản phẩm', href: '../showcase' }]"
        />
      </div>
      <div>
        <v-btn color="primary" class="mr-4" @click="previewDialog = !previewDialog"
          ><v-icon class="mr-2"> mdi-airplay </v-icon><span>Xem trước</span></v-btn
        >
        <v-btn color="primary" @click="newDialog = !newDialog" v-if="canEdit"
          ><v-icon class="mr-2">mdi-plus</v-icon><span>Thêm mới ảnh</span></v-btn
        >
      </div>
    </div>
    <v-card class="pa-2 mx-md-2">
      <v-data-table
        item-key="id"
        class="px-2"
        v-model="selected"
        :headers="headers"
        :items="showcases"
        :items-per-page="5"
        :search="search"
        :loading="loading"
      >
        <template v-slot:item.action="{ item }" v-if="canEdit">
          <v-btn @click="remove(item)" icon><v-icon>mdi-delete</v-icon></v-btn>
        </template>
        <template v-slot:item.image="{ item }">
          <v-img
            max-height="360"
            max-width="360"
            :src="getImage(item)"
            aspect-ratio="1.6667"
            contain
            class="ma-1"
          ></v-img>
        </template>
        <template v-slot:item.major="{ item }">
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <div v-on="on">
                <router-link
                  v-if="item.major"
                  style="text-decoration: none; white-space: nowrap"
                  :to="getMajor(item.major).id"
                  >{{ getMajor(item.major).code }}</router-link
                >
              </div>
            </template>
            <span>{{ getMajor(item.major).title }}</span>
          </v-tooltip>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>
<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import ShowcaseSliderNewDialog from '@/modules/showcase/ShowcaseSliderNewDialog'
import ShowcaseSliderPreviewDialog from '@/modules/showcase/ShowcaseSliderPreviewDialog'
import Breadcrumbs from '@/components/layout/Breadcrumbs.vue'
import KebapMenu from '@/components/basic/menu/KebapMenu'
import { get } from 'lodash'
export default {
  components: {
    Breadcrumbs,
    KebapMenu,
    ShowcaseSliderNewDialog,
    ShowcaseSliderPreviewDialog
  },
  props: {
    role: String
  },
  data() {
    return {
      loading: false,
      newDialog: false,
      previewDialog: false,
      selectedShowcase: {},
      headers: [
        {
          text: 'Ảnh',
          value: 'image',
          align: 'left',
          sortable: false,
          show: true
        },
        {
          text: 'Tên',
          value: 'title',
          align: 'left',
          sortable: false,
          show: true
        },
        {
          text: 'Mô Tả',
          value: 'description',
          align: 'left',
          sortable: false,
          show: false
        },
        {
          text: 'Hành Động',
          value: 'action',
          align: 'left',
          sortable: false,
          show: true,
          width: 100
        }
      ],
      selected: [],
      draw: false,
      search: '',
      status: null,
      sortBy: 'updatedAt',
      sortDesc: true
    }
  },
  async created() {
    this.loading = true
    await this.fetchMajors({ department: this.department.id })
    await this.fetchShowcases({
      department: this.department.id,
      position_contains: 'home-page'
    })
    this.selectedShowcase = this.showcases[0]
    this.loading = false
  },
  computed: {
    ...mapState('app', ['department']),
    ...mapGetters('showcases', ['showcases', 'majors']),
    ...mapGetters('auth', ['role']),
    canEdit() {
      return ['education_manager', 'super_admin'].includes(this.role.type)
    }
  },
  methods: {
    ...mapActions('showcases', [
      'fetchShowcases',
      'fetchMajors',
      'removeShowcases',
      'removeShowcase',
      'updateShowcase',
      'destroyAvatar'
    ]),
    refresh(data) {
      const { major, position, search } = data
      let query = {}
      if (position) query.position = { $regex: `.*${position}.*` }
      if (major) query.major = major
      this.fetchShowcases({ department: this.department.id, ...query })
      if (search) this.search = search
    },
    updateDraw(draw) {
      this.draw = draw
    },
    onShowcaseSelected(showcase) {
      this.setShowcase(showcase)
    },
    getPosition: position => {
      if (!position) return ''
      if (position.trim() === ',') return ''
      return position
    },
    getMajor: major => {
      return major || {}
    },
    getImage: item => {
      const imgUrl = get(item, 'image[0].url', 'https://cdn.vuetifyjs.com/images/cards/docks.jpg')
      if (!/^http/.test(imgUrl)) {
        return `${process.env.VUE_APP_API_ENDPOINT}${imgUrl}`
      } else {
        return imgUrl
      }
    },
    remove(item) {
      this.$dialog.confirm({
        title: 'Xóa sản phẩm',
        text: 'Bạn có chắc muốn xóa ảnh này?',
        okText: 'Có',
        cancelText: 'Không',
        done: async () => {
          this.$loading.active = true
          await this.removeShowcase(item.id)
          await this.destroyAvatar(item.image[0].id)
          this.$loading.active = false
        }
      })
    }
  },
  filters: {
    getRoot(root) {
      return root ? root.title : ''
    }
  }
}
</script>
<style scoped>
.container {
  max-width: 100% !important;
}
</style>
